import { useResponsiveDesign } from '@zola/zola-ui/src/contexts/ResponsiveDesignContext/ResponsiveDesignContext';

import { CardShelf } from '~/components/common/cards/CardShelf/CardShelf';
import { VendorCardVendor } from '~/components/common/cards/util/types';
import VendorCard, { VendorCardProps } from '~/components/common/cards/VendorCard/VendorCard';

type VendorCardShelfProps = {
  cardList: VendorCardVendor[];
  getCardProps?: (vendor: VendorCardVendor) => Partial<VendorCardProps>;
  onClick?: () => void;
  className?: string;
};

const VendorCardShelf = ({
  cardList,
  className,
  onClick,
  getCardProps = () => ({}),
  ...rest
}: VendorCardShelfProps & Partial<VendorCardProps>) => {
  const { isDesktop } = useResponsiveDesign();
  return (
    <CardShelf className={className} hoverScaleAdjust={false}>
      {cardList.map((vendor, index) => (
        <VendorCard
          key={vendor.storefrontUuid}
          vendor={vendor}
          position={index + 1}
          showDetails={false}
          showOverlayBadge={false}
          onClick={() => {
            onClick?.();
          }}
          scaleOnHover={false}
          altScaleOnHover={true}
          showVendorType={false}
          showCarousel={isDesktop}
          trackClick={false}
          {...getCardProps(vendor)}
          {...rest}
        />
      ))}
    </CardShelf>
  );
};

export default VendorCardShelf;
